import { IStoreResponseData } from '@dataTypes/userInfo';
import { getDaysInMonth } from 'date-fns';

export const DEMO_STORE_ID = 900001;
export const DEMO_STORE_NAME = '체험매장';

export const demoStoreState = (authority = 'ROLE_MANAGER'): IStoreResponseData => ({
  currentStore: DEMO_STORE_NAME,
  currentAuthority: authority,
  currentStoreId: DEMO_STORE_ID,
  storeLists: [
    {
      storeId: DEMO_STORE_ID,
      storeName: DEMO_STORE_NAME,
      authority,
      businessNum: '0000000000',
      mileageDisplayYn: 'Y',
    },
  ],
});

const MACHINES = [
  { catId: '10000001', deviceAlias: '세탁기 1', deviceId: 1, sortOrder: 1 },
  { catId: '10000002', deviceAlias: '세탁기 2', deviceId: 2, sortOrder: 2 },
  { catId: '10000003', deviceAlias: '건조기 1', deviceId: 3, sortOrder: 3 },
];

const monthKey = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

export const demoMonthSales = (yyyyMm?: string) => {
  const now = new Date();
  const key = yyyyMm && /^\d{4}-\d{2}$/.test(yyyyMm) ? yyyyMm : monthKey(now);
  const [year, month] = key.split('-').map(Number);
  const days = getDaysInMonth(new Date(year, month - 1, 1));
  const isCurrent = now.getFullYear() === year && now.getMonth() + 1 === month;
  const lastDay = isCurrent ? now.getDate() : days;
  const list = Array.from({ length: lastDay }, (_, index) => {
    const day = index + 1;
    const wave = 1 + ((day * 3) % 5) * 0.12;
    return {
      date: `${key}-${String(day).padStart(2, '0')}`,
      card: Math.round(78000 * wave),
      cash: day % 3 === 0 ? 6000 : 0,
      etc: day % 4 === 0 ? 4000 : 0,
    };
  });
  const sum = (pick: 'card' | 'cash' | 'etc') => list.reduce((acc, row) => acc + row[pick], 0);
  const todayRow = list[list.length - 1];
  const yesterdayRow = list[list.length - 2];
  const todaySales = todayRow ? todayRow.card + todayRow.cash + todayRow.etc : 0;
  const yesterdaySales = yesterdayRow
    ? yesterdayRow.card + yesterdayRow.cash + yesterdayRow.etc
    : 214000;

  return {
    currentMonth: isCurrent,
    lastMonthlySales: 8421500,
    monthlySalesByCard: sum('card'),
    monthlySalesByCash: sum('cash'),
    monthlySalesByEtc: sum('etc'),
    todaySales,
    yesterdaySales,
    totalMonthlySales: sum('card') + sum('cash') + sum('etc'),
    list,
  };
};

const stamp = (time: string) => {
  const now = new Date();
  const yy = String(now.getFullYear()).slice(2);
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yy}${mm}${dd}${time}`;
};

export const demoTotalSales = () => ({
  currentPage: 1,
  next: false,
  totalSales: [
    {
      id: 9001,
      transactionStatus: 'A',
      method: 'CARD',
      amount: 6000,
      tax: 0,
      serviceCharge: 0,
      installmentPeriod: '00',
      approvalNum: '38192014',
      catId: MACHINES[0].catId,
      cardNum: '9410-12**-****-4412',
      businessNum: '0000000000',
      cardCompany: '신한카드',
      transactionDate: stamp('143218'),
      vanKey: 'DEMO9001',
      deviceAlias: MACHINES[0].deviceAlias,
    },
    {
      id: 9002,
      transactionStatus: 'A',
      method: 'CARD',
      amount: 8000,
      tax: 0,
      serviceCharge: 0,
      installmentPeriod: '00',
      approvalNum: '38192055',
      catId: MACHINES[2].catId,
      cardNum: '5532-08**-****-1190',
      businessNum: '0000000000',
      cardCompany: '국민카드',
      transactionDate: stamp('111042'),
      vanKey: 'DEMO9002',
      deviceAlias: MACHINES[2].deviceAlias,
    },
    {
      id: 9003,
      transactionStatus: 'A',
      method: 'CASH',
      amount: 6000,
      tax: 0,
      serviceCharge: 0,
      installmentPeriod: '00',
      approvalNum: '110293',
      catId: MACHINES[1].catId,
      cardNum: '',
      businessNum: '0000000000',
      cardCompany: '',
      transactionDate: stamp('093511'),
      vanKey: 'DEMO9003',
      deviceAlias: MACHINES[1].deviceAlias,
    },
  ],
});

export const demoSumSales = () => ({
  totalSales: 20000,
  cardSales: 14000,
  cashSales: 6000,
  etcSales: 0,
});

const deviceSales = () => {
  const today = new Date();
  const yyyymmdd = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(
    today.getDate(),
  ).padStart(2, '0')}`;
  return [
    {
      ...MACHINES[0],
      coin: 12,
      card: 186000,
      cash: 12000,
      etc: 4000,
      cardCnt: 31,
      cashCnt: 2,
      etcCnt: 1,
      sortOrder: 1,
      date: yyyymmdd,
      oneDay: 174000,
      twoDay: 168000,
    },
    {
      ...MACHINES[1],
      coin: 8,
      card: 142000,
      cash: 6000,
      etc: 0,
      cardCnt: 24,
      cashCnt: 1,
      etcCnt: 0,
      sortOrder: 2,
      date: yyyymmdd,
      oneDay: 136000,
      twoDay: 129000,
    },
    {
      ...MACHINES[2],
      coin: 5,
      card: 98000,
      cash: 0,
      etc: 8000,
      cardCnt: 14,
      cashCnt: 0,
      etcCnt: 2,
      sortOrder: 3,
      date: yyyymmdd,
      oneDay: 91000,
      twoDay: 88000,
    },
  ];
};

export const demoDeviceLists = () =>
  MACHINES.map((machine) => ({
    catId: machine.catId,
    deviceAlias: machine.deviceAlias,
    deviceId: machine.deviceId,
    sortOrder: machine.sortOrder,
  }));

export const demoDeviceSales = () => deviceSales();

export const demoCharge = (year: number) => {
  const now = new Date();
  const lastMonth =
    year < now.getFullYear() ? 12 : year === now.getFullYear() ? now.getMonth() + 1 : 0;
  return Array.from({ length: lastMonth }, (_, index) => {
    const month = index + 1;
    const card = 2800000 + month * 120000;
    const fee = Math.round(card * 0.015);
    return {
      depositDate: `${year}${String(month).padStart(2, '0')}`,
      totalCardSales: card,
      totalFees: fee,
      totalCardDepositAmount: card - fee,
    };
  });
};

export const demoPeak = (kind?: string) => {
  if (kind === 'year') {
    const months = Array.from({ length: 12 }, (_, index) => {
      const month = index + 1;
      const net = month <= new Date().getMonth() + 1 ? 3200000 + month * 180000 : 0;
      const previous = 3000000 + month * 150000;
      return {
        month,
        net_amount: net,
        previous_amount: previous,
        delta: net === 0 ? null : net - previous,
      };
    });
    const yearTotal = months.reduce((acc, row) => acc + row.net_amount, 0);
    const previousYearTotal = months.reduce((acc, row) => acc + row.previous_amount, 0);
    return {
      yearTotal,
      previousYearTotal,
      monthCount: new Date().getMonth() + 1,
      previousMonthCount: 12,
      months,
    };
  }

  if (kind === 'hour') {
    const hours = [8, 9, 10, 11, 12, 18, 19, 20, 21].map((hour) => ({
      hour_of_day: hour,
      txn_count: 4 + (hour % 5),
      net_amount: 18000 + hour * 1200,
    }));
    return { hours, hoursByWeekday: hours };
  }

  if (kind === 'trend') {
    const rising = deviceSales().map((row) => ({
      cat_id: row.catId,
      device_alias: row.deviceAlias,
      current_amount: row.card,
      previous_amount: row.oneDay,
      delta: row.card - row.oneDay,
      current_count: row.cardCnt,
      previous_count: row.cardCnt - 2,
    }));
    return {
      week: { currentLabel: '이번 주', previousLabel: '지난 주', rising, falling: [] },
      monthCompare: { currentLabel: '이번 달', previousLabel: '지난 달', rising, falling: [] },
    };
  }

  return {
    devices: deviceSales().map((row) => ({
      cat_id: row.catId,
      device_alias: row.deviceAlias,
      txn_count: row.cardCnt + row.cashCnt + row.etcCnt,
      net_amount: row.card + row.cash + row.etc,
    })),
  };
};

export const demoTerminals = () =>
  MACHINES.map((machine) => ({
    catId: machine.catId,
    businessNum: '0000000000',
    terminalName: machine.deviceAlias,
    usageStatus: '00',
    isConnected: true,
    connectedSessionCount: 1,
    stock: 20,
  }));

export const demoCoinHistory = () => ({
  totalElements: 1,
  totalPages: 1,
  items: [
    {
      type: 'ADMIN_REQUEST',
      currentCoin: 12,
      coinDelta: 2,
      createdDate: new Date().toISOString(),
    },
  ],
});
